import { render } from "./Overdues.vue?vue&type=template&id=d44753a8"
import script from "./Overdues.vue?vue&type=script&lang=js"
export * from "./Overdues.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__